export const REPORT_COLORS = {
  primary: '#4F46E5',
  purple: '#7C3AED',
  green: '#16A34A',
  orange: '#F97316',
  red: '#EF4444',
}

export const SEVERITY_COLORS = {
  critical: '#EF4444',
  serious: '#F97316',
  moderate: '#EAB308',
  minor: '#3B82F6',
}

export const SEVERITY_BAR_CLASSES = {
  Critical: 'bg-red-500',
  Serious: 'bg-orange-500',
  Moderate: 'bg-yellow-500',
  Minor: 'bg-blue-500',
}

export function scoreColor(score) {
  if (score >= 90) return REPORT_COLORS.green
  if (score >= 50) return REPORT_COLORS.orange
  return REPORT_COLORS.red
}

export function scoreTextClass(score) {
  if (score >= 90) return 'text-green-600'
  if (score >= 50) return 'text-orange-600'
  return 'text-red-600'
}

export function sampleTrendPoints(points = [], maxBars = 20) {
  if (!points.length) return []
  if (points.length <= maxBars) return points
  const step = (points.length - 1) / (maxBars - 1)
  const sampled = []
  for (let i = 0; i < maxBars; i += 1) {
    sampled.push(points[Math.round(i * step)])
  }
  return sampled
}

export function formatReportDate(value, withTime = false) {
  if (!value) return 'N/A'
  return new Date(value).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    ...(withTime ? { hour: 'numeric', minute: '2-digit', hour12: true } : {}),
  })
}

export function formatScoreChange(scoreChange) {
  if (scoreChange == null) return ''
  return `${scoreChange >= 0 ? '+' : ''}${scoreChange}% since monitoring began`
}
